module.exports = __webpack_public_path__ + "static/serverBio3-28f6d5161cd7735d3678ae4a1e41a0e5.png";